<div class="modal-header">
  <h5 class="modal-title">
    Pastas
  </h5>
</div>

<div class="modal-body">
  <label
    class="table-repos"
    *ngFor="let repository of repositories?.data"
  >
    <input type="radio" [(ngModel)]="repoId" [value]="repository.id" name="repos" (change)="selectRepoHandler()" />
    <span>{{ repository.name }}</span>
  </label>

  <div>
    <button class="btn btn-invite-add-repo" type="button" (click)="addRepo()">
      <i class="fas fa-plus"></i> Adicionar pasta
    </button>

    <form class="d-flex justify-content-center mt-0 mb-2 hide-form" #formRepo>
      <input
        [(ngModel)]="repoName"
        name="repoName"
        class="form-control ml-3"
        type="text"
        placeholder="Nome da pasta"
        aria-label="Nome da pasta"
      />
    </form>
  </div>

  <div class="row">
    <div class="col">
      <mat-paginator
        [hidden]="isRepositoriesEmpty"
        [length]="page.total"
        [pageSize]="page.page"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="page.current"
        showFirstLastButtons
        (page)="pageEvent = getData($event)"
      ></mat-paginator>
    </div>
  </div>
</div>

<div class="modal-footer">
  <!-- <button type="button" class="btn btn-link mainFontColor" (click)="activeModal.dismiss()">Voltar</button>
  <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader class="btn btn-primary mainBackground-color">
    Salvar
  </button> -->
  <button type="button" class="btn btn-link mainFontColor" (click)="activeModal.dismiss()">Voltar</button>
  <button type="button" class="btn btn-primary mainBackground-color" (click)="inviteHandler()">
    Salvar
  </button>
</div>
